<template>
  <div
    id="peligros"
    v-if="$store.state.global_privilegio_admin_registro_peligro.ver">
    <AdminMenu />
    <div class="row justify-content-md-center align-items-center">
      <div class="col-md-10">
        <div class="row container_admin">
          <!-- LISTA DE CLIENTES -->
          <div class="col-6 text-left mt-2">
            <b class="titulo">Peligros</b>
          </div>
          <div class="col-6 d-flex justify-content-between mt-3">
            <button
              v-show="$store.state.global_privilegio_admin_registro_peligro.crear"
              type="button"
              class="btn boton_guardar1"
              data-toggle="modal"
              data-target="#agregarsubcla"
              style="margin-right: 3%"
            >
              <img
                src="img/iconos/registrar_subcla.png"
                alt="logo-color"
                class="icono mr-2"
              />Nueva Subclasificación
            </button>
            <button
              v-show="$store.state.global_privilegio_admin_registro_peligro.crear"
              type="button"
              class="btn boton_guardar1"
              data-toggle="modal"
              data-target="#agregarpeligro"
              style="margin-right: 1%"
            >
              <img
                src="img/iconos/registrar_peligro.png"
                alt="logo-color"
                class="icono mr-2"
              />Nuevo Peligro
            </button>
          </div>
          <div class="col-12 table mt-3">
            <v-client-table
              class="col-md-12 mt-3"
              :columns="columns"
              :data="informacion_peligro"
              :options="options"
            >
              <div slot="subcla" slot-scope="props">
                  <div class="row">
                    <div class="col-md-2">
                      <button
                        class="btn boton_guardar"
                        type="button"
                        @click="consultar_subclasificacion(props.row.id)"
                      >
                        Actualizar
                      </button>
                    </div>
                    <div class="col-md-6">
                      <select
                        :id="'select' + props.row.id"
                        class="form-control boton_texto ml-5"
                        onchage="consultar_subcla()"
                      >
                        <option selected value="">Sin actualizar</option>
                      </select>
                    </div>
                  </div>
              </div>
              <div slot="opciones" slot-scope="props">
                  <button
                    class="btn dropdown-toggle boton_12"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <ul class="dropdown-menu b-dropdown-opt" role="menu">
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="consultar_peligros_subcla(props.row.id)"
                            v-show="
                              $store.state.global_privilegio_admin_registro_peligro
                                .editar
                            "
                            >&nbsp;<b>Editar General</b></a
                          >
                        </li>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="eliminar_subcla(props.row.id)"
                            v-show="
                              $store.state.global_privilegio_admin_registro_peligro
                                .eliminar
                            "
                            >&nbsp;<b>Eliminar Subclasificación</b></a
                          >
                        </li>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="eliminar_peligro(props.row.id)"
                            v-show="
                              $store.state.global_privilegio_admin_registro_peligro
                                .eliminar
                            "
                            >&nbsp;<b>Eliminar Peligro</b></a
                          >
                        </li>
                    </ul>
                  </button>
              </div>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL AGREGAR PELIGRO -->
    <div
      class="modal fade"
      id="agregarpeligro"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"><b>Nuevo Peligro</b></label> <br />
            </div>
            <div class="box-body row">
              <div class="col-md-3"></div>
              <div class="col-md-6">
                <form v-on:submit.prevent="agregar_peligro()">
                  <textarea
                    v-model.trim.lazy="peligro"
                    class="form-control Mayus boton_texto"
                    placeholder="Nuevo Peligro"
                  ></textarea
                  ><br />
                  <center>
                    <button type="submit" class="btn boton_guardar btn-lg">
                      Guardar
                    </button>
                  </center>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL AGREGAR SUBCLASIFICACIÓN -->
    <div
      class="modal fade"
      id="agregarsubcla"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"><b>Nueva Subclasificación</b></label>
              <br />
            </div>
            <div class="box-body row">
              <div class="col-md-1"></div>
              <div class="col-md-3">
                <label class="color_letra">Elegir el Peligro:</label>
                <select
                  class="custom-select boton_texto"
                  v-model="n_peligro"
                  @change="consultar_peligros()"
                >
                  <option selected value="">Seleccione el Peligro</option>
                  <option
                    v-for="(item_peligro, index) of nuevos_peligros"
                    :key="index"
                  >
                    {{ item_peligro.sub_peligro }}
                  </option>
                </select>
                <input
                  type="hidden"
                  v-model="id_peligro"
                  class="form-control"
                  readonly
                />
              </div>
              <div class="col-md-6">
                <label class="color_letra"
                  >Ingrese Nueva Subclasificación:</label
                >
                <input
                  type="text"
                  v-model="subclasificacion"
                  class="form-control boton_texto"
                  placeholder="Nueva Subclasificación"
                /><br />
              </div>
              <div class="col-md-5"></div>
              <center>
                <button
                  type="submit"
                  class="btn boton_guardar btn-lg"
                  @click="agregar_subcla()"
                >
                  Guardar
                </button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EDITAR GENERAL -->
    <div
      class="modal fade"
      id="editargeneral"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"
                ><b>Editar Peligro y Subclasificación</b></label
              >
              <br />
            </div>
            <div class="box-body row">
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <label class="color_letra">Peligro:</label>
                <input
                  type="text"
                  v-model.trim.lazy="con_peligro"
                  class="form-control boton_texto"
                /><br />
              </div>
              <div class="col-md-4">
                <label class="color_letra">Subclasificacion:</label>
                <input
                  type="text"
                  v-model.trim.lazy="con_subclasificacion"
                  class="form-control boton_texto"
                /><br />
              </div>
              <div class="col-md-12">
                <center>
                  <button
                    type="submit"
                    class="btn boton_guardar btn-lg"
                    @click="editar_peligro_subcla()"
                  >
                    Guardar
                  </button>
                  <button
                    type="submit"
                    class="btn boton_guardar btn-lg"
                    @click="vaciar_variables()"
                  >
                    Cancelar
                  </button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="alert alert-warning" role="alert" v-else>
    No tiene permiso para ver el Módulo
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "../../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "peligros",
  components: {
    AdminMenu,
  },
  data() {
    return {
      // VARIABLE ARRAY
      nuevos_peligros: [],

      // VARIABLES REGISTRO PELIGRO y SUBCLASIFICACIÓN
      id_peligro: "",
      peligro: "",
      n_peligro: "",
      subclasificacion: "",

      // VARIABLE CONSULTAR
      con_key_sub: "",
      con_key_peli: "",
      con_peligro: "",
      con_registrado: "",
      con_subclasificacion: "",

      // VARIABLES PARA LA TABLA PELIGROS
      informacion_peligro: [],
      columns: ["peligro", "subcla", "opciones"],
      options: {
        headings: {
          peligro: "Peligro",
          subcla: "Subclasificación",
          opciones: "Opciones",
        },
        sortable: ["peligro", "subcla", "opciones"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
      },
    };
  },
  created() {
    if (
      this.$store.state.global_privilegio_admin_registro_peligro.ver == true
    ) {
      this.tabla_peligros();
    }
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + yyyy;

    var docRef2 = db.collection("nuevo_peligro").orderBy("p_nuevo_peligro");
    docRef2.onSnapshot((querySnapshot) => {
      // LIMPIAR ARRAY ANTES DE CONSULTAR
      this.nuevos_peligros = [];
      querySnapshot.forEach((doc) => {
        this.nuevos_peligros.push({
          id_peligro: doc.id,
          sub_peligro: doc.data().p_nuevo_peligro,
        });
      });
    });
  },
  methods: {
    // TABLA PELIGROS
    tabla_peligros() {
      if (this.informacion_peligro.length > 0) {
      } else {
        this.informacion_peligro = [];
        db.collection("nuevo_peligro")
          .orderBy("p_hora_registro", "desc")
          .onSnapshot((snapshot) => {
            let changes = snapshot.docChanges();
            changes.forEach((change) => {
              if (change.type === "added") {
                this.informacion_peligro.unshift({
                  id: `${change.doc.id}`,
                  peligro: `${change.doc.data().p_nuevo_peligro}`,
                });
              } else if (change.type === "modified") {
                for (
                  let index = 0;
                  index < this.informacion_peligro.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_peligro[index].id) {
                    this.informacion_peligro.splice(index, 1);
                  }
                }
                this.informacion_peligro.unshift({
                  id: `${change.doc.id}`,
                  peligro: `${change.doc.data().p_nuevo_peligro}`,
                });
              } else if (change.type === "removed") {
                for (
                  let index = 0;
                  index < this.informacion_peligro.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_peligro[index].id) {
                    this.informacion_peligro.splice(index, 1);
                  }
                }
              } else {
              }
              // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
              let set = new Set(this.informacion_peligro.map(JSON.stringify));
              this.informacion_peligro = Array.from(set).map(JSON.parse);
            });
          });
      }
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS PELIGRO
    agregar_peligro() {
      if (this.peligro) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();

        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA

        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        let newClienteRef = db.collection("nuevo_peligro").doc();
        let id = newClienteRef.id;

        db.collection("nuevo_peligro")
          .doc(id)
          .set({
            p_nuevo_peligro: this.peligro,
            p_fecha_registro: this.fecha,
            p_hora_registro: this.hora_actual,
            p_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
        NProgress.done();
        NProgress.remove();
        this.peligro = "";
        $("#agregarpeligro").modal("hide");
      }
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS PELIGRO
    agregar_subcla() {
      if (this.subclasificacion == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        let newClienteRef = db.collection("nuevo_subclasificacion").doc();
        let id = newClienteRef.id;
        db.collection("nuevo_subclasificacion")
          .doc(id)
          .set({
            p_nuevo_subclasificacion: this.subclasificacion,
            p_id_peligro: this.id_peligro,
            p_fecha_registro: this.fecha,
            p_hora_registro: this.hora_actual,
            p_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.error("Error al guardar... ", error);
          });
        NProgress.done();
        NProgress.remove();
        this.subclasificacion = "";
        this.id_peligro = "";
        this.n_peligro = "";
        $("#agregarsubcla").modal("hide");
      }
    },

    // FUNCIÓN PARA MOSTRAR DATOS PELIGRO
    consultar_peligro(id_peligro) {
      NProgress.start();
      let docRef = db.collection("nuevo_peligro").doc(id_peligro);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.con_key_peli = doc.id;
          this.con_fecha = doc.data().p_fecha_registro;
          this.con_hora = doc.data().p_hora_registro;
          this.con_peligro = doc.data().p_nuevo_peligro;
        }
      });
      NProgress.done();
      NProgress.remove();
    },

    // VACIAR VARIABLES GENERAL
    vaciar_variables() {
      this.con_key_peli = "";
      this.con_peligro = "";
      this.con_key_sub = "";
      this.con_subclasificacion = "";
      $("#editargeneral").modal("hide");
    },

    consultar_peligros_subcla(id_peligro) {
      NProgress.start();
      let id_select = "select" + id_peligro;
      this.con_subclasificacion = document.getElementById(id_select).value;

      if (this.con_subclasificacion != "") {
        let query01 = db.collection("nuevo_peligro").doc(id_peligro);
        query01.get().then((doc) => {
          if (doc.exists) {
            this.con_key_peli = doc.id;
            this.con_peligro = doc.data().p_nuevo_peligro;
            this.con_fecha = doc.data().p_fecha_registro;
            this.con_hora = doc.data().p_hora_registro;
          }
        });

        let query02 = db
          .collection("nuevo_subclasificacion")
          .doc(this.con_subclasificacion);
        query02.get().then((doc) => {
          if (doc.exists) {
            this.con_key_sub = doc.id;
            this.con_subclasificacion = doc.data().p_nuevo_subclasificacion;
            this.con_fecha = doc.data().p_fecha_registro;
            this.con_hora = doc.data().p_hora_registro;
          }
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "No tiene subclasificación.",
          showConfirmButton: false,
          timer: 1500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
      $("#editargeneral").modal("show");
      NProgress.done();
      NProgress.remove();
    },

    // CONSULTAR ID DEL PELIGRO
    consultar_peligros() {
      db.collection("nuevo_peligro")
        .where("p_nuevo_peligro", "==", this.n_peligro)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.id_peligro = doc.id;
          });
        });
    },

    // CONSULTAR SUBCLASIFICACIÓN
    consultar_subclasificacion(id_peligro) {
      let id_p = "select" + id_peligro;
      let options = "";
      let docRef2 = db
        .collection("nuevo_subclasificacion")
        .orderBy("p_nuevo_subclasificacion", "asc");
      docRef2.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if (`${doc.data().p_id_peligro}` == id_peligro) {
            options =
              options +
              "<option value=" +
              `${doc.id}` +
              ">" +
              `${doc.data().p_nuevo_subclasificacion}` +
              "</option>";
          }
        });
        document.getElementById(id_p).innerHTML = options;
      });
    },

    // FUNCIÓN PARA MOSTRAR DATOS SUBCLASIFICACIÓN
    consultar_subcla(id_subcla) {
      NProgress.start();
      let docRef = db.collection("nuevo_subclasificacion").doc(id_subcla);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.con_key = doc.id;
          this.con_subcla = doc.data().p_nuevo_subclasificacion;
          this.con_registrado = doc.data().p_registrado_por;
        }
      });
      NProgress.done();
      NProgress.remove();
    },

    // FUNCIÓN PARA EDITAR PROCESO
    editar_peligro() {
      if (this.con_peligro == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        // FUNCIÓN PARA EDITAR
        db.collection("nuevo_peligro")
          .doc(this.con_key_peli)
          .set({
            p_nuevo_peligro: this.con_peligro,
            p_fecha_registro: this.con_fecha,
            p_hora_registro: this.con_hora,
            p_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
        NProgress.done();
        NProgress.remove();
        this.con_peligro = "";
        this.con_subclasificacion = "";
      }
    },

    editar_peligro_subcla() {
      if (this.con_subclasificacion == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        // FUNCIÓN PARA EDITAR
        let query03 = db
          .collection("nuevo_peligro")
          .doc(this.con_key_peli)
          .set({
            p_nuevo_peligro: this.con_peligro,
            p_fecha_registro: this.con_fecha,
            p_hora_registro: this.con_hora,
            p_registrado_por: this.$store.state.email,
          })
          .then(() => {});

        let query04 = db
          .collection("nuevo_subclasificacion")
          .doc(this.con_key_sub)
          .set({
            p_id_peligro: this.con_key_peli,
            p_nuevo_subclasificacion: this.con_subclasificacion,
            p_fecha_registro: this.con_fecha,
            p_hora_registro: this.con_hora,
            p_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
        NProgress.done();
        NProgress.remove();

        this.con_peligro = "";
        this.con_subclasificacion = "";
        $("#editargeneral").modal("hide");
      }
    },

    // ELIMINAR PROCESO
    eliminar_peligro(id_peligro) {
      db.collection("nuevo_peligro")
        .doc(id_peligro)
        .delete()
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Peligro eliminado satisfactoriamente.",
            showConfirmButton: false,
            timer: 1500,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        });
    },

    // FUNCIÓN PARA ELIMINAR SUBCLASIFICACIÓN
    eliminar_subcla(id_peligro) {
      let id_select_subcla = "select" + id_peligro;
      this.con_subclasificacion =
        document.getElementById(id_select_subcla).value;
      console.log(this.con_subclasificacion);

      db.collection("nuevo_subclasificacion")
        .doc(this.con_subclasificacion)
        .delete()
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Subclasificación eliminada correctamente.",
            showConfirmButton: false,
            timer: 1500,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        });
    },
  },
};
</script>